import { useEffect, useState } from "react";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";


function UpdateCountry({
    targetID,
    employee,
    setShowUpdateForm,
    setShowModal,
    triggerFetch,
}) {
    const [name, setName] = useState("");
    const axiosInstance = useAxiosInstance();

    useEffect(() => {
        async function fetchAndSetAds() {
            const { data } = await axiosInstance.get("countries/getSingleCountry/" + targetID);
            setName(data.name);
        }
        fetchAndSetAds();
    }, [targetID, axiosInstance]);

    async function handleSubmit(e) {
        e.preventDefault();

        const itemData = new FormData();
        itemData.append("name", name);

        const response = await axiosInstance.patch("countries/" + targetID, itemData);

        if (response.data) {
            setShowUpdateForm(false);
            setShowModal(false);
            triggerFetch();
        }
    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <ShortTextInput
                label={`Country Name`}
                value={name}
                placeholder={`Enter Country Name`}
                setState={setName}
            />

            <FormSubmitButton text="Update Country" />
        </Form>
    );
}

export default UpdateCountry;
